import React, { useId } from "react";
import styled from "styled-components";

const SwitchWrapper = styled.div`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  position: relative;
  width: 42px;
  height: 24px;
`;

const SwitchLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid
    ${(props) => (props.isOn ? "#ee754c" : "#d4cecb")};
  border-radius: 999px;
  cursor: pointer;
  background-color: ${(props) => (props.isOn ? "#ee754c" : "#e6e1df")};
  box-shadow: inset 0 1px 2px rgba(75, 51, 53, 0.08);
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease;

  &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 18px;
    height: 18px;
    background-color: white;
    border-radius: 50%;
    box-shadow: 0 2px 5px rgba(75, 51, 53, 0.22);
    transform: translateX(${(props) => (props.isOn ? "18px" : "0")});
    transition: transform 0.18s ease;
  }
`;

const SwitchInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;

  &:focus-visible + label {
    box-shadow: 0 0 0 3px rgba(238, 117, 76, 0.18);
  }
`;

const SwitchOnAndOff = ({ isOn, handleToggle, id, label = "Toggle setting" }) => {
  const generatedId = useId();
  const uniqueId = id || `switch-${generatedId.replace(/:/g, "")}`;

  return (
    <SwitchWrapper>
      <SwitchInput
        id={uniqueId}
        type="checkbox"
        checked={isOn}
        onChange={handleToggle}
        aria-label={label}
      />
      <SwitchLabel htmlFor={uniqueId} isOn={isOn} />
    </SwitchWrapper>
  );
};

export default SwitchOnAndOff;
